<template>
  <div id="interest" style="height:100%;position: relative;padding: 0 10px;">
    <div class="table-2" style="height: 100%;">
      <el-table
        :data="tableData"
        border
        v-loading="dataListLoading"
        @row-click="rowClick"
        style="width: 100%; height: 100%;"
        class="el-le"
      >
        <el-table-column
          min-width="70"
          prop="label"
          label='Symbol'
        >
        </el-table-column>
        <el-table-column
          min-width="30"
          prop="value"
          label='Interest Rates'
        >
        </el-table-column>
        <el-table-column
          min-width="20"
          prop="DATADATE"
          label='Date'
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getDataCommon } from "../../../../common/js/http/v3Api"
export default {
  props: {
    country: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      id: 'F01_03',
      pagesize: null,
      begindate: null,
      enddate: null,
      other: null,
      tableData: [],
      dataListLoading: false,
      rateData: []
    }
  },
  mounted() {
    this.getDataCommon()
  },
  methods: {
    async getDataCommon() {
      const { data } = await getDataCommon({
        'fcode': 'F01_03',
        'countryCode': this.country.countryCode,
        'pagesize': this.pagesize,
        't': new Date().getTime(),
        'other': this.other,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' })
      this.rateData = data.result.data
      this.tableData = this.rateData
      if (this.rateData != null && this.rateData.length !== 0) {
        this.isInterestRateCode()
      }
      this.dataListLoading = false
    },
    rowClick(row, event, column) {
      // if (this.code === '1' || this.code === 1 || this.code === '7' || this.code === 7 || this.code === '9' || this.code === 9 || this.code === '10' || this.code === 10) {
      this.$store.commit('common/updateInterestRateCode', row.fcode)
      this.$store.commit('common/updateInterestRateLabel', row.label)
      // }
    },
    isInterestRateCode() {
      if (this.tableData.length > 0 && this.tableData[0].fcode) {
        // if (this.code === '1' || this.code === 1 || this.code === '7' || this.code === 7 || this.code === '9' || this.code === 9 || this.code === '10' || this.code === 10) {
        this.$store.commit('common/updateInterestRateCode', this.tableData[0].fcode)
        this.$store.commit('common/updateInterestRateLabel', this.tableData[0].label)
        // }
      }
    }
  }
}
</script>
<style scoped lang="scss">
#interest .top {
  width: 100%;
}
#interest .clearfloat {
  clear: both;
}

#interest .table-2 {
  width: 100%;
  height: 90%;
}
/deep/.el-table {
  font-size: 14px;
  margin: 0 auto;
}
/deep/.el-table .warning-row {
  background: #e0e1e5;
}
/deep/.el-table .success-row {
  background: #e0e1e5;
}
/deep/.cell {
  text-align: left;
}
/deep/.el-table_1_column_1 {
  text-align: center !important;
}
/deep/.el-table_1_column_2 {
  padding-left: 10px !important;
}

/deep/tr:nth-of-type(even) {
  background: rgb(249, 245, 252);
}

/deep/.el-le {
  overflow: hidden;
}
/deep/.el-table__body-wrapper {
  font-size: 13px;
  color: #636363;
}
/deep/.el-table__row {
  height: 30px;
}
/deep/.el-table__header-wrapper {
  height: 26px;
  /*margin-bottom: 5px;*/
}
/deep/.el-table th {
  background: rgb(238, 247, 255);
  color: rgb(69, 155, 239);
  height: 26px;
  padding: 0;
}
/deep/.el-table--medium td,
/deep/.el-table--medium th,
/deep/.el-table td {
  padding: 0;
}
/deep/.el-table th > .cell {
  font-size: 14px;
}
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #ebecee;
}
/deep/.el-table .cell,
/deep/.el-table th div {
  padding: 0;
}
/deep/.el-card {
  border: none;
}
/deep/.el-table--border td,
/deep/.el-table td {
  border: none;
}
/deep/.el-table__empty-text {
  color: #fff0 !important;
}
.el-loading-spinner .path {
  stroke: #fff0;
}
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.66);
}
</style>
